import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-glove",
  "use": "icon-si-glyph-glove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-glove\" id=\"icon-si-glyph-glove\"><title>Glove</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g fill=\"#434343\"><g><path d=\"M13.807,9.708 C15.67,7.845 17.487,4.801 14.114,1.428 C12.251,-0.435 9.23,-0.435 7.367,1.428 L6.342,2.453 L6.342,1.734 C6.342,0.776 5.565,-0.001 4.607,-0.001 C3.648,-3.33934269e-16 3,0.777 3,1.735 L3,5.923 L2.153,6.642 L1.54,6.029 L0.313,7.256 L8.287,15.23 L9.514,14.003 L8.965,13.454 L13.807,9.708 L13.807,9.708 Z\" class=\"si-glyph-fill\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-glove.svg
// module id = 8Vj8
// module chunks = 62